import { render, staticRenderFns } from "./Associati.vue?vue&type=template&id=78a8483e&scoped=true"
import script from "./Associati.vue?vue&type=script&lang=js"
export * from "./Associati.vue?vue&type=script&lang=js"
import style0 from "./Associati.vue?vue&type=style&index=0&id=78a8483e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78a8483e",
  null
  
)

export default component.exports